import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import api  from '../../services/api';


export const useProductStore = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      const isFormData = body instanceof FormData;
      
      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
      
      const res = await api.post("/products/store", body, config);
      return res;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["viewproducts"] });
      await queryClient.refetchQueries({ queryKey: ["viewproducts"], type: "active" });
    },
  });

};
